import {
	applicationApprove,
	applicationByID,
	applicationList,
	applicationReject,
} from '@/services/academy/creators.service'

export default {
	namespaced: true,
	state: {
		applicationList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		application: {},

		applicationStatus: 'pending',
		applicationSaveStatus: 'init',
	},
	getters: {
		getApplicationList(state) {
			return state.applicationList
		},
		getApplication(state) {
			return state.application
		},
		getApplicationStatus(state) {
			return state.applicationStatus
		},
		getApplicationSaveStatus(state) {
			return state.applicationSaveStatus
		},
	},
	mutations: {
		APPLICATION_LIST(state, value) {
			state.applicationList = value
		},
		SET_APPLICATION(state, value) {
			state.application = value
		},
		APPLICATION_STATUS(state, value) {
			state.applicationStatus = value
		},
		APPLICATION_SAVE_STATUS(state, value) {
			state.applicationSaveStatus = value
		},
	},
	actions: {
		async fetchApplicationList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('APPLICATION_STATUS', 'pending')
			commit('APPLICATION_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await applicationList(params)
				commit('APPLICATION_STATUS', 'init')
				commit('APPLICATION_LIST', data)
				return data
			} catch (error) {
				commit('APPLICATION_STATUS', 'init')
				throw error
			}
		},
		async fetchApplicationByID({ commit }, params) {
			commit('APPLICATION_STATUS', 'pending')
			try {
				const { data } = await applicationByID(params)
				commit('APPLICATION_STATUS', 'init')
				commit('SET_APPLICATION', data.data)
				return data
			} catch (error) {
				commit('APPLICATION_STATUS', 'init')
				return error
			}
		},
		async approveApplication({ commit }, { id, data: payload }) {
			commit('APPLICATION_SAVE_STATUS', 'pending')
			try {
				const { data } = await applicationApprove(id, payload)
				commit('APPLICATION_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('APPLICATION_SAVE_STATUS', 'init')
				throw error
			}
		},
		async rejectApplication({ commit }, { id, data: payload }) {
			commit('APPLICATION_SAVE_STATUS', 'pending')
			try {
				const { data } = await applicationReject(id, payload)
				commit('APPLICATION_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('APPLICATION_SAVE_STATUS', 'init')
				throw error
			}
		},
	},
}
